import { useWebHaptics } from 'web-haptics/vue';
import { defaultPatterns, type WebHapticsOptions } from 'web-haptics';

type TPattern = 'success' | 'warning' | 'error'

export const useHaptics = (options?: WebHapticsOptions) => {
  const { trigger } = useWebHaptics(options);

  return (type: TPattern) => {
    switch (type) {
      case 'success':
        return trigger(defaultPatterns.success);
      case 'warning':
        return trigger(defaultPatterns.warning);
      case 'error':
        return trigger(defaultPatterns.error, { intensity: 0.9 });
    }
  };
};
